import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router';
import { MenuTrigger, Button, Popover, Menu, MenuItem } from 'react-aria-components';
import { NavigateRoutes } from '@features/routing/routesObject';
import smallMenuIcon from '@assets/icons/small-menu-icon.svg';
import { SALES_NETWORK_LANGUAGES } from '@@/languageConfig';



const SmallMenu = () => {
	const { t } = useTranslation('web');

	const navigate = useNavigate();

	return (
		<div className='header-section small-menu-section'>
			<MenuTrigger>

				<Button className='small-menu-button disable-selection' autoFocus={false}>
					<img src={smallMenuIcon} alt='small-menu-button-icon' />
				</Button>

				<Popover>
					<Menu onAction={(key: string | number) => navigate(String(key))} autoFocus={false}>
						
						<MenuItem id={NavigateRoutes.about} textValue={t('layouts.header.aboutUs')}>
							<Link to={NavigateRoutes.about}>{t('layouts.header.aboutUs')}</Link>
						</MenuItem>
						
						<MenuItem id={NavigateRoutes.gallery} textValue={t('layouts.header.gallery')}>
							<Link to={NavigateRoutes.gallery}>{t('layouts.header.gallery')}</Link>
						</MenuItem>
						
						<MenuItem id={NavigateRoutes.partners} textValue={t('layouts.header.forPartners')}>
							<Link to={NavigateRoutes.partners}>{t('layouts.header.forPartners')}</Link>
						</MenuItem>

						<MenuItem id={NavigateRoutes.faq} textValue={t('layouts.header.faq')}>
							<Link to={NavigateRoutes.faq}>{t('layouts.header.faq')}</Link>
						</MenuItem>

						{SALES_NETWORK_LANGUAGES && SALES_NETWORK_LANGUAGES.length > 0 &&
							<MenuItem id={NavigateRoutes.salesNetwork} textValue={t('layouts.header.salesNetwork')}>
								<Link to={NavigateRoutes.salesNetwork}>{t('layouts.header.salesNetwork')}</Link>
							</MenuItem>
						}
					</Menu>
				</Popover>

			</MenuTrigger>
		</div>
	);
}

export default SmallMenu;